import { httpClient } from './httpClient';

const base = '/api/pago-metodos';

export const listarMetodos = () => httpClient.get(base);
